import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { ConfigProvider } from './contexts/ConfigContext.jsx';
import { SubscriptionProvider } from './contexts/SubscriptionContext.jsx';
import { AnonymousProvider } from './contexts/AnonymousContext.jsx';
import { DashboardProvider } from './contexts/DashboardContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

// Public pages
import LandingPage from './pages/LandingPage.jsx';
import PricingPage from './pages/PricingPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import SignupPage from './pages/SignupPage.jsx';
import ForgotPasswordPage from './pages/ForgotPasswordPage.jsx';
import ResetPasswordPage from './pages/ResetPasswordPage.jsx';
import PaymentSuccessPage from './pages/PaymentSuccessPage.jsx';
import ArticleListPage from './pages/ArticleListPage.jsx';
import ArticleDetailPage from './pages/ArticleDetailPage.jsx';

// App pages
import DashboardPage from './pages/DashboardPage.jsx';
import GamePage from './pages/GamePage.jsx';
import SpeedGamePage from './pages/SpeedGamePage.jsx';
import StatsPage from './pages/StatsPage.jsx';
import TrainingGuidesPage from './pages/TrainingGuidesPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ConfigProvider>
            <AnonymousProvider>
              <SubscriptionProvider>
                <DashboardProvider>
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/payment-success" element={<PaymentSuccessPage />} />
                    
                    {/* Public Articles/Blog */}
                    <Route path="/articles" element={<ArticleListPage />} />
                    <Route path="/articles/:slug" element={<ArticleDetailPage />} />
                    
                    {/* N-Back Training - accessible to everyone (anonymous or logged in) */}
                    <Route path="/n-back" element={<GamePage />} />
                    <Route path="/speed-training" element={<SpeedGamePage />} />
                    
                    {/* Legacy route redirect */}
                    <Route path="/game" element={<Navigate to="/n-back" replace />} />
                    
                    {/* Protected routes */}
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <DashboardPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/stats"
                      element={
                        <ProtectedRoute>
                          <StatsPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/guides"
                      element={
                        <ProtectedRoute>
                          <TrainingGuidesPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute>
                          <ProfilePage />
                        </ProtectedRoute>
                      }
                    />
                    
                    {/* Catch-all redirect */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </DashboardProvider>
              </SubscriptionProvider>
            </AnonymousProvider>
          </ConfigProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;

